<template>
  <div class="container event__content-container">
    <EventInfo
      class="event__content-card event-info_full-width"
      :event-id="eventId"
    />
    <EventCompanyProfile
      id="event-company-profile"
      class="event__content-card"
    />
    <EventUsers id="event-users" class="event__content-card" />
    <EventPasses
      :event-id="eventId"
      id="event-passes"
      class="event__content-card"
    />
  </div>
</template>
<script>
import EventInfo from "@/components/Custom/EventInfo.vue";
import { mapGetters } from "vuex";
import EventCompanyProfile from "@/components/Custom/EventCompanyProfile.vue";
import EventUsers from "@/components/Custom/EventUsers.vue";
import EventPasses from "@/components/Custom/EventPasses.vue";

export default {
  name: "ParticipantInstaller",

  components: {
    EventPasses,
    EventUsers,
    EventCompanyProfile,
    EventInfo
  },
  computed: {
    ...mapGetters("event", ["eventId", "isServiceShown"])
  }
};
</script>
